export default __webpack_public_path__ + "static/media/nikita.ab3d1743.jpeg";